import { useMemo } from "react";
import { IFullPairingPosition, IPairingPosition, sortCrewByDisplayOrder } from "@vmosolutions/oc-interfaces";
import { Grid, Typography } from "@mui/material";
import { PairingPositionCell } from "src/components/FilterSearchTable/CustomCellComponents/PairingPositionCell";

export interface IDisplayCrewOnPairing {
  pairingPositions: IFullPairingPosition[];
  containerRef: React.MutableRefObject<HTMLDivElement>;
  iteration: number;
}

/**
 * Display crew slots on pairing
 * @param props -
 * @returns
 */
export const DisplayCrewOnPairing = (props: IDisplayCrewOnPairing): JSX.Element => {
  const { pairingPositions, containerRef, iteration } = props;

  const pairingCrewInfo: IPairingPosition[] = useMemo(() => {
    return pairingPositions?.length > 0
      ? pairingPositions.sort(sortCrewByDisplayOrder).map((fpp) => ({
          position: fpp?.position?.title,
          crew_id: fpp?.crew?._id,
          givenName: fpp?.crew?.firstName,
          surname: fpp?.crew?.lastName,
          employeeId: fpp?.crew?.employeeId,
          openFlyingStatus: fpp?.openFlyingStatus,
        }))
      : [];
  }, [pairingPositions]);

  return (
    <Grid ref={containerRef} key={iteration} container wrap="nowrap" style={{ width: "100%", margin: 8 }}>
      <Typography variant="body2" style={{ width: 100, fontSize: 12 }}>
        Crew Positions
      </Typography>
      <PairingPositionCell positions={pairingCrewInfo} displayCrewName={true} retainDisplayOrder={true} />
    </Grid>
  );
};
